import { render } from "./ComponentList.vue?vue&type=template&id=52ce00a1&scoped=true"
import script from "./ComponentList.vue?vue&type=script&lang=js"
export * from "./ComponentList.vue?vue&type=script&lang=js"

import "./ComponentList.vue?vue&type=style&index=0&id=52ce00a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ce00a1"]])

export default __exports__